import { useState, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import ReactLoading from 'react-loading';

import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Map, { Source, Layer } from 'react-map-gl';

import optc from '../optc.json'

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';

import {
  getAllAgencies, getUser,
  getUserAgency,
  getLayoverStats,
  getLayoverStatsBlock,
  getTripTrace,
  getTripPoints
} from '../API.js';


import { useTranslation } from "react-i18next";

const Styles = styled.div
  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  th

  td { background-color: white; }

  td:nth-child(1) { 
    background: #79508f ;
    color: white }
  
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  const [filterInput, setFilterInput] = useState("");

  const handleFilterChange = e => {
    const value = e.target.value || undefined;
    setFilter("blocknum", value); // Update this specific field
    setFilterInput(value);
  };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },

    },
    useFilters,
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }


  // Render the UI for your table
  return (


    <>
      {!headerGroups[0].headers.find((e) => { return e.id == 'trip_id' }) ? <div className="row">
        <div className="col-12 text-center">
          <input
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={t("blockoperation.find")}
          />
        </div>
      </div > : ''}
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Véhicule' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")} {' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 25, 50, 100].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}


function BlockOperation() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const [blocks, setBlocks] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: <div>{t('blockoperation.blocknum')}</div>,
        accessor: 'blocknum',
        Cell: props => (
          <div
            style={{ cursor: 'pointer' }}
            onClick={(e) => handleBlockClick(e)}>
            {props.value}
          </div>
        ),
      },
      // {
      //   Header: <div>Date</div>,
      //   accessor: 'date',
      //   Cell: props => <div> {props.value ? dayjs(props.value).format('YYYY-MM-DD') : ''} </div>,
      // },
      // {
      //   Header: <div>{t('routeoperation.table2.veh')}</div>,
      //   accessor: 'vehicle_id',
      // },
      {
        Header: <div>{t('blockoperation.tripcnt')}</div>,
        accessor: 'tripcnt',
      },
      {
        Header: <div>{t('blockoperation.planlayover1')}<br /><div>{t('blockoperation.planlayover2')}</div></div>,
        accessor: 'planlayover',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : 0} </div>
      },
      {
        Header: <div>{t('blockoperation.layoveravailable1')}<br /><div>{t('blockoperation.layoveravailable2')}</div></div>,
        accessor: 'layoveravailable',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : 0} </div>
      },
      {
        Header: <div>{t('blockoperation.layoverused1')}<br /><div>{t('blockoperation.layoverused2')}</div></div>,
        accessor: 'usedlayover',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : 0} </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('blockoperation.layoveroveruse1')}<br /><div>{t('blockoperation.layoveroveruse2')}</div></div>,
        accessor: 'layoveroveruse',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : 0} </div>
      },
      {
        Header: <div>{t('blockoperation.layoveroveruse1')}<br /><div>{t('blockoperation.layoveroveruse3')}</div></div>,
        accessor: 'layoveroverusepct',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : 0}% </div>
      },
      {
        Header: <div>{t('blockoperation.layoveroveruse1')}<br />
        {t('blockoperation.layoveroveruse4')}<br />
        {t('blockoperation.layoveroveruse5')}
        </div>,
        accessor: 'lopt',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : 0} </div>
      },
      {
        Header: <div>{t('routeoperation.table2.otp1')}<br /><div>{t('routeoperation.table2.otp2')}</div></div>,
        accessor: 'on_time_pct',
        Cell: props => <div> {props.value ? props.value.toFixed(1) + '%' : ''}  </div>
      },
    ],
    [blocks]
  )


  const columns2 = useMemo(
    () => [
      {
        Header: <p>{t('routeoperation.table2.trip')}</p>,
        accessor: 'trip_id',
        Cell: props => {
          const { trip_id, vehicle_id, date, planstart, route_id, direction_id } = props.row.original; // Access both values
          return (
            <div style={{ cursor: 'pointer' }} onClick={() => handleTripClick(trip_id, vehicle_id, date, planstart, route_id, direction_id)}>
              {trip_id}
            </div>
          );
        },
      },
      {
        Header: <div>Date</div>,
        accessor: 'date',
        Cell: props => <div> {props.value ? dayjs(props.value).format('YYYY-MM-DD') : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.veh')}</div>,
        accessor: 'vehicle_id',
      },
      {
        Header: <p>{t('routeoperation.table1.route')}</p>,
        accessor: 'route_id',
      },
      {
        Header: <p>Direction</p>,
        accessor: 'direction_id',
      },
      {
        Header: <div>{t('blockoperation.prevplanarrival1')}<br />
          {t('blockoperation.prevplanarrival2')}<br />
          {t('blockoperation.prevplanarrival3')}</div>,
        accessor: 'prev_plan_arrival',
        Cell: props => <div> {props.value !== 'ND' ? new Date(props.value * 1000).toISOString().substring(11, 16) : 'ND'} </div>,
      },
      {
        Header: <div>{t('blockoperation.prevrealarrival1')}<br />
          {t('blockoperation.prevrealarrival2')}<br />
          {t('blockoperation.prevrealarrival3')}</div>,
        accessor: 'prev_real_arrival',
        Cell: props => <div> {props.value !== 'ND' ? new Date(props.value * 1000).toISOString().substring(11, 16) : 'ND'}</div>,
      },
      {
        Header: <div>{t('blockoperation.planstart1')}<br />
          {t('blockoperation.planstart2')}</div>,
        accessor: 'planstartiso',
        Cell: props => <div> {props.value !== 'ND' ? new Date(props.value * 1000).toISOString().substring(11, 16) : 'ND'}</div>,
      },
      {
        Header: <div>{t('blockoperation.realstart1')}<br />
          {t('blockoperation.realstart2')}</div>,
        accessor: 'realstartiso',
        Cell: props => <div> {props.value !== 'ND' ? new Date(props.value * 1000).toISOString().substring(11, 16) : 'ND'} </div>,
      },
      {
        Header: <div>{t('blockoperation.layoverused1')}<br /><div>{t('blockoperation.layoverused2')}</div></div>,
        accessor: 'usedlayover',
        Cell: props => <div> {props.value ? ((props.value) / 60).toFixed(1) : 0} </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('blockoperation.layoveroveruse1')}<br /><div>{t('blockoperation.layoveroveruse2')}</div></div>,
        accessor: 'layoveroveruse',
        Cell: props => <div> {props.value ? ((props.value) / 60).toFixed(1) : 0} </div>
      },
      {
        Header: <div>{t('routeoperation.table2.otp1')}<br /><div>{t('routeoperation.table2.otp2')}</div></div>,
        accessor: 'on_time_pct',
        Cell: props => <div> {props.value ? props.value.toFixed(1) + '%' : ''}  </div>
      },
    ],
    []
  )


  const [user, setUser] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');
  const [groupAgencies, setGroupAgencies] = useState('');
  const [loading, setLoading] = useState(0);

  const [block, setBlock] = useState('');
  const [blockClick, setBlockClick] = useState(0);
  const [trips, setTrips] = useState([]);
  const [showTrips, setShowBlocks] = useState(false);

  const [tripClick, setTripClick] = useState('');
  const [vehTrip, setVehTrip] = useState('');
  const [dateTrip, setDateTrip] = useState('');
  const [tripStart, setTripStart] = useState('');
  const [tripDir, setTripDir] = useState('');
  const [inbound, setInbound] = useState('');
  const [route, setRoute] = useState('');

  const mapRef = useRef();
  const [mapIsLoaded, setMapIsLoaded] = useState(false);
  const [zoomValue, setZoomValue] = useState(11);
  const [hoveredFeature, setHoveredFeature] = useState('');
  const [stopsGeom, setStopsGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [traceGeom, setTraceGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [tracePoints, setTracePoints] = useState({ "type": "FeatureCollection", "features": [] });

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey1, setRefreshKey1] = useState(0);
  const [refreshKey2, setRefreshKey2] = useState(0);
  const [refreshKey3, setRefreshKey3] = useState(0);

  // const [refresh, setRefresh] = useState(0);

  const [initDate, setInitDate] = useState(dayjs().add(-1, 'day').format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState(new Date(Date.now() - 86400_000));
  const [endDate, setEndDate] = useState(new Date(Date.now() - 86400_000));
  const [startFormat, setStartFormat] = useState('');
  const [endFormat, setEndFormat] = useState('');

  const [vehClick, setVehClick] = useState('yes');

  useEffect(() => {
    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency()
      .then(response => {
        setGroupAgencies(response);
        setUserAgency(response);
      })

  }, []);


  useEffect(() => {

    setLoading(1);

    Promise.all([
      getLayoverStats(agency, startFormat, endFormat),
      //getValuesPrevious(agency, startFormat, endFormat)
    ])
      .then(([layoverResponse]) => {

        setBlocks(layoverResponse);
        setLoading(0);

      })
      .catch(error => {
        // Handle error if any of the async operations fail
        console.error("Error:", error);
      });

  }, [refreshKey]);


  useEffect(() => {
    if (block !== '' && showTrips == true) {

      getLayoverStatsBlock(agency, startFormat, endFormat, block)
        .then(response => {
          setTrips(response);
        })

    }
  }, [refreshKey1]);


  useEffect(() => {

    if (tripClick) {

      console.log(tripClick)

      setTraceGeom({ "type": "FeatureCollection", "features": [] });
      setTracePoints({ "type": "FeatureCollection", "features": [] });

      getTripTrace(agency, startFormat, tripClick, dateTrip)
        .then((response) => {
          setTraceGeom(response[0].jsonb_build_object);
        })
      getTripPoints(agency, startFormat, endFormat, tripClick, vehTrip, dateTrip, 1)
        .then((response) => {
          setTracePoints(response[0].jsonb_build_object)
        })
    }

  }, [refreshKey2])


  useEffect(() => {
    zoomToLocation();
  }, [refreshKey3])


  function handleBlockClick(e) {

    setShowBlocks(true);
    setBlock(e.target.innerHTML);
    setRefreshKey1(oldKey => oldKey + 1);
    setRefreshKey3(oldKey => oldKey + 1);

  }


  const handleTripClick = (trip_id, vehicle_id, date, start, route_id, dir) => {
    setTripClick(trip_id);
    setVehTrip(vehicle_id);
    setTripStart(start);
    setRoute(route_id);
    setTripDir(dir);
    setDateTrip(dayjs(date).format('YYYY-MM-DD'));
    setRefreshKey2(oldKey => oldKey + 1);
  }


  const handleOnLoad = () => {
    setMapIsLoaded(true);
  }


  const handleChangeDate = (dates) => {

    const [start, end] = dates;

    if (dayjs(start).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')) {
      setInitDate(dayjs().format('YYYY-MM-DD'));
    }

    setStartDate(start);
    setEndDate(end);
    setEndFormat('');

    if (end !== null) {

      setLoading(1);

      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');

      setBlock('');
      setBlockClick(0);

      setShowBlocks(false);

      setStartFormat(formatstart);
      setEndFormat(formatend);
      setInitDate(dayjs().add(1, 'day').format('YYYY-MM-DD'));
      setRefreshKey(oldKey => oldKey + 1);
    }

  };

  const zoomToLocation = () => {
    if (mapIsLoaded == true && user !== 'admin') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[1],
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[0]
        ],
        duration: 2000,
        zoom: 9
      });
    } else if (mapIsLoaded == true && user == 'admin') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == agency).latlong[1],
          optc.optc.find((e) => e.operateur == agency).latlong[0]
        ],
        duration: 2000,
        zoom: 9
      });
    }

  }

  const onHover = event => {
    const feature = event.features?.find(f => f.layer.id === "stop-points");

    if (feature) {
      setHoveredFeature({
        feature: feature,
        x: event.point.x,
        y: event.point.y
      });
    } else {
      setHoverInfo(null);
    }
  };


  const onMouseOut = () => {
    setHoveredFeature(null);
  };


  const renderTooltip = () => {
    if (!hoveredFeature) return null;

    const { x, y, feature } = hoveredFeature;

    // Example: show the feature id or any property
    return (
      <div
        style={{
          position: "absolute",
          left: x,
          top: y,
          background: "white",
          padding: "4px 6px",
          pointerEvents: "none",
          borderRadius: 3,
          fontSize: 12,
          transform: "translate(10px, -10px)"
        }}
      >
        <div>{feature.properties?.time.split('.')[0] ?? "Point"}</div>
        <div>{feature.properties?.speed.toFixed(0) + ' km/h' ?? "Point"}</div>
      </div>
    );
  };



  return (

    user && userAgency && blocks ?

      <>
        <div className="row justify-content-center ps-1 pe-1">
          <h1 id="page-title" className="display-5">{t('blockoperation.title')}</h1>
          {Array.isArray(groupAgencies) && groupAgencies.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : groupAgencies[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          {loading == 0 ? '' :
            <div className="ponctualitetripspinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}

          <div className="d-flex justify-content-center pt-3 pb-2">
            <DatePicker
              selected={startDate}
              onChange={handleChangeDate}
              locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
              inline
              startDate={startDate}
              endDate={endDate}
              selectsRange
              excludeDateIntervals={[
                {
                  start: new Date('2000-01-01'),
                  end: new Date('2023-07-01')
                },
                {
                  start: new Date(dayjs().format('YYYY-MM-DD')),
                  end: new Date('2030-12-31')
                },
              ]}
            />
          </div>

          {Array.isArray(groupAgencies) && groupAgencies.length > 1 ? <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-12">
              <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                <option defaultValue>Opérateur</option>
                {groupAgencies.map((e) => (
                  <option value={e} key={e}
                  >{e}</option>
                ))}
              </select>
            </div>
          </div> : ''}


          <div className="row justify-content-center">
            <div className="col text-center pt-3">
              <h3>{(startFormat == endFormat || endFormat == '') ?
                dayjs(startDate).format('YYYY-MM-DD') :
                t("datatable.from") + ' ' + dayjs(startDate).format('YYYY-MM-DD') + ' ' + t("datatable.to") + ' ' + dayjs(endDate).format('YYYY-MM-DD')}</h3>
              {/* <h5 className="display-7">Inclus les départs après minuit</h5> */}
            </div>
          </div>

          <div className="col pt-2 pb-2">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns} data={blocks} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {block !== '' && showTrips == true ? <div className="col pt-2 pb-2">
            <h3 className="text-center pt-2 pb-2">{t("blockoperation.blocknum")} {block}</h3>
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns2} data={trips} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div> : ''}


          <div className="row justify-content-center pt-3">
            <div className="col-lg-12 col-sm-12 pt-3 pb-4">
              <h3 className="text-center">{tripClick ? dateTrip + ' ' + t("routeoperation.route") + route
                + ' direction ' + (tripDir == inbound ? t('tripotp.in') : t('tripotp.out'))
                + ' ' + t('tripotp.at') + ' ' + new Date(tripStart * 1000).toISOString().substring(11, 16)
                + ' ' + t("routeoperation.table2.veh") + ' ' + vehTrip : ''}</h3>
              <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                <Map
                  initialViewState={{
                    latitude: 45.556827,
                    longitude: -73.662362,
                    zoom: zoomValue
                  }}
                  style={{ width: '100%', height: '40vh' }}
                  ref={ref => mapRef.current = ref && ref.getMap()}
                  interactiveLayerIds={["stop-points"]}
                  onLoad={handleOnLoad}
                  onMouseEnter={onHover}
                  onMouseLeave={onMouseOut}
                  mapStyle="mapbox://styles/wdoucetk/cjun8whio1ha21fmzxt8knp7k"
                  mapboxAccessToken={process.env.REACT_APP_MAPBOX_KEY}
                  attributionControl={false}
                >

                  {renderTooltip()}
                  <Source
                    id={"stops"}
                    type="geojson" data={tripClick ? { "type": "FeatureCollection", "features": [] } : stopsGeom}
                  >
                    <Layer {...{
                      "id": "stops",
                      "type": "circle",
                      "source": "stops",
                      "paint": {
                        "circle-radius": 3,
                        "circle-color": "white",
                        "circle-stroke-width": 1,
                        "circle-stroke-color": user == 'admin' ?
                          optc.optc.find((e) => e.operateur == agency).color :
                          optc.optc.find((e) => e.operateur == userAgency[0]).color
                      }
                    }} />
                  </Source>

                  <Source
                    id={"points"}
                    type="geojson" data={tripClick ? tracePoints : { "type": "FeatureCollection", "features": [] }}
                  >
                    <Layer {...{
                      "id": "stop-points",
                      "type": "circle",
                      "source": "points",
                      "paint": {
                        "circle-radius": 3,
                        "circle-color": '#4d0077',
                        "circle-stroke-width": 1,
                        "circle-stroke-color": '#4d0077'
                      }
                    }} />
                  </Source>
                  <Source
                    id={"route_dir"}
                    type="geojson" data={tripClick ? traceGeom : { "type": "FeatureCollection", "features": [] }}
                  >
                    <Layer {...{
                      "beforeId": "stops",
                      "id": "trace",
                      'type': 'line',
                      "source": "route_dir",
                      "layout": {
                        "line-join": "round",
                        "line-cap": "round",
                        "visibility": "visible"
                      },
                      "paint": {
                        'line-width': 1,
                        'line-color': user == 'admin' ?
                          optc.optc.find((e) => e.operateur == agency).color :
                          optc.optc.find((e) => e.operateur == userAgency[0]).color
                      }
                    }} />
                  </Source>
                </Map>
              </div>
            </div>
          </div>


        </div>
      </> :
      <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="d-flex justify-content-center">
          <div className="row">
            <div className="col-sm">
              <h1 className="display-5">{t('data.loading')}</h1>
              <div className="d-flex justify-content-center">
                <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default BlockOperation;

